module.exports = __webpack_public_path__ + "img/DSC_0089.f99d3593.jpg";